/** @format */

import React, { FunctionComponent, useState } from 'react';
import I18n from '../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import MvnoBlockRequestState from '../../interfaces/platform/MvnoBlockRequestState';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { DateHelper } from '../../helpers/DateHelper';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import CardHeader from '../../components/Card/CardHeader';
import { GoToCallBlock }         from '../PlkFunctions/GoToCallBlock';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import MvnoBlockRequest          from '../../interfaces/platform/MvnoBlockRequest';
import AlertInfo                 from '../../components/Info/AlertInfo';
import { operationAction }       from '../../modules/block/OperationStatus';
import { FormGeneralHelper }     from '../../helpers/FormGeneral';
import { provisionigConstants }  from '../../modules/provisioning/action';
import { ItemLoaders }           from '../../core/loaders/ItemLoaders';
import { useDispatch }           from 'react-redux';
import { provConstant }          from '../../modules/provisioning/ProvisioningConnect';
import { BlockChangeParams }     from '../Provisioning/Block/BlockChangeParams';
import COLORS                    from "../../assets/themes/OPL/colors";

export type MvnoBlockStateViewHeaderType = {
    mvnoBlockRequest: MvnoBlockRequest;
    stateBlock: MvnoBlockRequestState;
    functionName: string;
    editColor: string;
    cancelColor: string;
    setGet: string;
};

export const MvnoBlockStateViewHeader: FunctionComponent<MvnoBlockStateViewHeaderType> = ({
    stateBlock,
    functionName,
    editColor,
    cancelColor,
    setGet,
    mvnoBlockRequest,
}) => {
    const dispatch = useDispatch();
    const [alert, setAlert] = useState<any>(null);
    const [changeParamsDialog, setChangeParamsDialog] = useState(false);
    const [editStateBlock, setEditStateBlock] = useState<MvnoBlockRequestState | null>(null);
    let errorState = null;
    if (stateBlock.messageResponseJson) {
        const state = JSON.parse(stateBlock.messageResponseJson);
        if (state && state.error) {
            errorState = state.error;
        }
    }
    const allowAction = mvnoBlockRequest.operationStatus !== null && !stateBlock.stepFinish;

    const skipFunction = (): void => {
        setAlert(
            <AlertInfo
                onConfirm={(): void => {
                    const itemLoader = new ItemLoaders(dispatch);
                    itemLoader.putWithCallback(
                        FormGeneralHelper.getUrl('/operation_on_blocks/' + mvnoBlockRequest.id),
                        provisionigConstants.OPERTATION_ON_BLOCK,
                        {
                            id: mvnoBlockRequest.id,
                            mvnoBlockRequestStateId: stateBlock.id,
                            operationType: operationAction.OPERATION_SKIP_CURRENT_POSITION,
                        },
                        (data: any) => {
                            dispatch({
                                type: provConstant.MVNO_BLOCK_VIEW_RELOAD,
                                reload: true,
                            });
                        },
                        { propagateDataToCallback: true }
                    );
                }}
                onCancel={(): void => setAlert(null)}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content="prov:f.confirm_skip_from_current_place"
            />
        );
    };

    return (
        <CardHeader>
            <GridContainer>
                <GridItem xs={11} style={{ backgroundColor:  COLORS.DARK_FUNCTION.FUNCTION_3 }}>
                    <Typography variant="subtitle1">
                        <I18n trans="prov:f.state_id" />
                        {stateBlock.id + ' '}
                        <I18n trans={functionName} />
                    </Typography>
                </GridItem>
                <GridItem xs={1} style={{ textAlign: 'right', backgroundColor: COLORS.ADDITIONAL.ADDITIONAL_5 }}>
                    <Typography variant="subtitle1">{setGet}</Typography>
                </GridItem>
                <GridItem xs={2}>
                    <I18n trans="prov:vb.block_start" />
                </GridItem>
                <GridItem xs={2}>{DateHelper.format(stateBlock.createdAt)}</GridItem>
                <GridItem xs={2}>
                    <I18n trans="prov:vb.block_end" />
                </GridItem>
                <GridItem xs={6}>{DateHelper.format(stateBlock.lastRequestProcessed)}</GridItem>

                <GridItem xs={2}>
                    <I18n trans="prov:vb.count_request" />
                </GridItem>
                <GridItem xs={2}>{stateBlock.requestCounter}</GridItem>
                <GridItem xs={2}>
                    <I18n trans="prov:vb.max_count_request" />
                </GridItem>
                <GridItem xs={6}>{stateBlock.requestLimit}</GridItem>

                <GridItem xs={2}>
                    <I18n trans="prov:vb.sleep_time_before_execute" />
                </GridItem>
                <GridItem xs={10}>{stateBlock.sleepSeconds}s</GridItem>

                {errorState && (
                    <GridItem xs={12}>
                        <Typography component="h6" color="error">
                            {errorState}
                        </Typography>
                    </GridItem>
                )}
                <GridItem xs={12} style={{ textAlign: 'right' }}>
                    {stateBlock && (stateBlock.calledMvnoBlockRequestId || stateBlock.messageRequest) && (
                        <GoToCallBlock mvnoBlockRequestState={stateBlock} />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_BLOCK_CHANGE_PARAMS) && (
                        <CustomTextButtom
                            callback={(): void => {
                                setChangeParamsDialog(true);
                                setEditStateBlock(stateBlock);
                            }}
                            color={editColor}
                            label="prov:vb.change_params"
                            disabled={!allowAction}
                            size="sm"
                        />
                    )}
                    {UserRoleHelper.checkRole(roles.ROLE_BLOCK_OPERATION_ON_BLOCK) && (
                        <CustomTextButtom
                            callback={skipFunction}
                            color={cancelColor}
                            label="prov:vb.mark_as_correct_and_go_to_next"
                            disabled={!allowAction}
                            size="sm"
                        />
                    )}
                    {alert}
                    {editStateBlock && (
                        <BlockChangeParams
                            open={changeParamsDialog}
                            close={(): void => {
                                setChangeParamsDialog(false);
                                setEditStateBlock(null);
                            }}
                            mvnoBlockRequest={mvnoBlockRequest}
                            mvnoBlockRequestState={editStateBlock}
                        />
                    )}
                </GridItem>
            </GridContainer>
        </CardHeader>
    );
};
